import { c as _c } from "react/compiler-runtime";
import CommonAnimationHeight from "@/components/utils/animation/CommonAnimationHeight";
import { CREATE_WAVE_VALIDATION_ERROR } from "@/helpers/waves/create-wave.validation";
import { APPROVE_WAVE_TAB_LABEL_MAX_LENGTH, DEFAULT_APPROVE_WAVE_TAB_LABELS, getEffectiveApproveWaveTabLabels } from "@/helpers/waves/wave-metadata.helpers";
import type { CreateWaveApproveDisplayConfig } from "@/types/waves.types";
import type { ChangeEvent } from "react";
export default function CreateWaveDisplaySettings(t0) {
  const $ = _c(45);
  const {
    display,
    errors,
    onChange
  } = t0;
  const hasLengthError = errors.includes(CREATE_WAVE_VALIDATION_ERROR.APPROVE_WAVE_TAB_LABEL_TOO_LONG);
  const hasDuplicateError = errors.includes(CREATE_WAVE_VALIDATION_ERROR.APPROVE_WAVE_TAB_LABELS_DUPLICATE);
  const hasReservedError = errors.includes(CREATE_WAVE_VALIDATION_ERROR.APPROVE_WAVE_TAB_LABEL_RESERVED);
  const errorMessage = hasLengthError ? `Labels must be ${APPROVE_WAVE_TAB_LABEL_MAX_LENGTH} characters or fewer.` : hasDuplicateError ? "Use two different tab labels." : hasReservedError ? "Labels cannot match existing tabs." : null;
  let t1;
  if ($[0] !== display) {
    t1 = getEffectiveApproveWaveTabLabels(display);
    $[0] = display;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const labels = t1;
  let t2;
  if ($[2] !== display || $[3] !== onChange) {
    t2 = key => event => {
      onChange({
        ...display,
        [key]: event.target.value
      });
    };
    $[2] = display;
    $[3] = onChange;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onLabelChange = t2;
  let t3;
  if ($[5] !== errorMessage) {
    t3 = hasValue => `${errorMessage ? "tw-caret-error tw-ring-error focus:tw-border-error focus:tw-ring-error" : "tw-border-white/5 tw-caret-primary-400 tw-ring-white/5 hover:tw-ring-white/10 focus:tw-border-primary-500/50 focus:tw-ring-primary-400"} ${hasValue ? "tw-text-primary-400 focus:tw-text-white" : "tw-text-white"} tw-form-input tw-block tw-w-full tw-appearance-none tw-rounded-lg tw-border-0 tw-bg-iron-900 tw-px-4 tw-py-3 tw-text-base tw-font-medium tw-shadow-inner tw-ring-1 tw-ring-inset tw-transition tw-duration-300 tw-ease-out placeholder:tw-text-iron-500 focus:tw-bg-iron-900 focus:tw-outline-none sm:tw-text-sm`;
    $[5] = errorMessage;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const inputClasses = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="tw-mb-0 tw-text-sm tw-font-semibold tw-text-iron-200">Display settings</p>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <label htmlFor="create-wave-approvals-tab-label" className="tw-block tw-text-sm tw-font-medium tw-text-iron-400">Approvals tab label</label>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = display.approvalsTabLabel;
  let t7;
  if ($[9] !== onLabelChange) {
    t7 = onLabelChange("approvalsTabLabel");
    $[9] = onLabelChange;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = Boolean(errorMessage);
  const t9 = errorMessage ? "create-wave-display-settings-error" : undefined;
  const t10 = inputClasses(display.approvalsTabLabel.length > 0);
  let t11;
  if ($[11] !== display.approvalsTabLabel || $[12] !== t10 || $[13] !== t7 || $[14] !== t8 || $[15] !== t9) {
    t11 = <div className="tw-space-y-2">{t5}<input id="create-wave-approvals-tab-label" type="text" autoComplete="off" maxLength={APPROVE_WAVE_TAB_LABEL_MAX_LENGTH} value={t6} onChange={t7} placeholder={DEFAULT_APPROVE_WAVE_TAB_LABELS.approvals} aria-invalid={t8} aria-describedby={t9} className={t10} /></div>;
    $[11] = display.approvalsTabLabel;
    $[12] = t10;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <label htmlFor="create-wave-approved-tab-label" className="tw-block tw-text-sm tw-font-medium tw-text-iron-400">Approved tab label</label>;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  const t13 = display.approvedTabLabel;
  let t14;
  if ($[18] !== onLabelChange) {
    t14 = onLabelChange("approvedTabLabel");
    $[18] = onLabelChange;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  const t15 = Boolean(errorMessage);
  const t16 = errorMessage ? "create-wave-display-settings-error" : undefined;
  const t17 = inputClasses(display.approvedTabLabel.length > 0);
  let t18;
  if ($[20] !== display.approvedTabLabel || $[21] !== t14 || $[22] !== t15 || $[23] !== t16 || $[24] !== t17) {
    t18 = <div className="tw-space-y-2">{t12}<input id="create-wave-approved-tab-label" type="text" autoComplete="off" maxLength={APPROVE_WAVE_TAB_LABEL_MAX_LENGTH} value={t13} onChange={t14} placeholder={DEFAULT_APPROVE_WAVE_TAB_LABELS.approved} aria-invalid={t15} aria-describedby={t16} className={t17} /></div>;
    $[20] = display.approvedTabLabel;
    $[21] = t14;
    $[22] = t15;
    $[23] = t16;
    $[24] = t17;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== t11 || $[27] !== t18) {
    t19 = <div className="tw-grid tw-grid-cols-1 tw-gap-3 md:tw-grid-cols-2">{t11}{t18}</div>;
    $[26] = t11;
    $[27] = t18;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <span className="tw-rounded-md tw-bg-iron-900 tw-px-3 tw-py-1.5">Chat</span>;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== labels.approvals) {
    t21 = <span className="tw-rounded-md tw-bg-iron-800 tw-px-3 tw-py-1.5 tw-text-iron-200">{labels.approvals}</span>;
    $[30] = labels.approvals;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== labels.approved) {
    t22 = <span className="tw-rounded-md tw-bg-iron-800 tw-px-3 tw-py-1.5 tw-text-iron-200">{labels.approved}</span>;
    $[32] = labels.approved;
    $[33] = t22;
  } else {
    t22 = $[33];
  }
  let t23;
  if ($[34] !== t21 || $[35] !== t22) {
    t23 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-text-sm tw-font-semibold tw-text-iron-400">{t20}{t21}{t22}</div>;
    $[34] = t21;
    $[35] = t22;
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  let t24;
  if ($[37] !== errorMessage) {
    t24 = errorMessage ? <div id="create-wave-display-settings-error" className="tw-relative tw-flex tw-items-center tw-gap-x-2 tw-pt-1.5"><svg className="tw-size-4 tw-flex-shrink-0 tw-text-error" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><div className="tw-relative tw-z-10 tw-text-xs tw-font-medium tw-text-error">{errorMessage}</div></div> : null;
    $[37] = errorMessage;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] !== t24) {
    t25 = <CommonAnimationHeight>{t24}</CommonAnimationHeight>;
    $[39] = t24;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  let t26;
  if ($[41] !== t19 || $[42] !== t23 || $[43] !== t25) {
    t26 = <div className="tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-700 tw-pt-6"><div className="tw-space-y-3">{t4}{t19}{t23}{t25}</div></div>;
    $[41] = t19;
    $[42] = t23;
    $[43] = t25;
    $[44] = t26;
  } else {
    t26 = $[44];
  }
  return t26;
}